import React, { useRef, useEffect, useState } from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";
import styles from './PortfolioBlock.module.scss';

function PortfolioBlock(props) {
   const {image, live, source, title} = props;
   const boxRef = useRef();
   const [visible, setVisible] = useState(false);
   useEffect(() => {
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.2 }
      );
      if (boxRef.current) observer.observe(boxRef.current);
      return () => observer.disconnect();
   }, []);

   return (
      <Box ref={boxRef} className={`${styles.portfolioBlock} ${visible ? styles.fadeIn : ''}`}>
         <Box component={'img'} src={image} alt={`${title} project mockup`} className={styles.image} />
         <h3 style={{marginBottom: '0.5rem'}}>{title}</h3>
         <Box className={styles.links} display={'flex'} flexDirection={'row'} justifyContent={'center'} gap={'1rem'}>
            {live && <IconLink link={live} title={'Live Demo'} icon={'fa fa-safari'}/>}
            {source && <IconLink link={source} title={'Source Code'} icon={'fa fa-github'}/>}
         </Box>
      </Box>
   );
}

export default PortfolioBlock;